export var CheckboxMarkCssClass;
(function (CheckboxMarkCssClass) {
    CheckboxMarkCssClass["Base"] = "iress-checkbox-mark";
    CheckboxMarkCssClass["Checked"] = "iress-checkbox-mark--checked";
    CheckboxMarkCssClass["CheckedMark"] = "iress-checkbox-mark__checked-mark";
    CheckboxMarkCssClass["Indeterminate"] = "iress-checkbox-mark--indeterminate";
    CheckboxMarkCssClass["IndeterminateMark"] = "iress-checkbox-mark__indeterminate-mark";
})(CheckboxMarkCssClass || (CheckboxMarkCssClass = {}));
//# sourceMappingURL=checkbox-mark.types.js.map